import src from "IMAGE";
export default { src, width: 457, height: 273, blurWidth: 0, blurHeight: 0};
